import { render, staticRenderFns } from "./ClientsGrid.vue?vue&type=template&id=bf4f5748&scoped=true"
import script from "./ClientsGrid.vue?vue&type=script&lang=ts"
export * from "./ClientsGrid.vue?vue&type=script&lang=ts"
import style0 from "./ClientsGrid.vue?vue&type=style&index=0&id=bf4f5748&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4f5748",
  null
  
)

export default component.exports